// src/components/eventos/EventosHome.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';

/* ---- Ícones SVG ---- */
const CalendarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
    </svg>
);
const EditIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);
const UserTieIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="7" r="4" /><path d="M12 11l-2 5 2 3 2-3-2-5" /><path d="M5.5 21a8 8 0 0 1 13 0" />
    </svg>
);
const FileAltIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
    </svg>
);
const CogsIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
);
const MicIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" y1="19" x2="12" y2="23" /><line x1="8" y1="23" x2="16" y2="23" />
    </svg>
);
const ArrowRightIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
);
const ArrowLeftIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const LogoutIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);
const ChevronIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const MODULOS = [
    {
        id: 'cadastro', title: 'Cadastro de Eventos', description: 'Crie novos eventos ou edite eventos existentes',
        Icon: EditIcon, path: '/eventos/cadastro', perfis: ['super_admin', 'admin', 'diretor'],
        gradient: 'linear-gradient(135deg, #2CCB90, #2DB8E1)',
        topBorder: 'linear-gradient(90deg, #2CCB90, #2DB8E1)',
        glow: 'rgba(44,203,144,0.18)', glowColor: '#2CCB90', accentColor: '#16a974',
    },
    {
        id: 'diretor', title: 'Visão do Diretor', description: 'Painel executivo com visão estratégica dos eventos',
        Icon: UserTieIcon, path: '/eventos/diretor', perfis: ['super_admin', 'admin', 'diretor'],
        gradient: 'linear-gradient(135deg, #818cf8, #a78bfa)',
        topBorder: 'linear-gradient(90deg, #818cf8, #a78bfa)',
        glow: 'rgba(129,140,248,0.18)', glowColor: '#818cf8', accentColor: '#7c3aed',
    },
    {
        id: 'relatorios', title: 'Relatórios e Documentos', description: 'Visualize detalhes e métricas dos eventos cadastrados',
        Icon: FileAltIcon, path: '/eventos/relatorios', perfis: ['super_admin', 'admin', 'diretor'],
        gradient: 'linear-gradient(135deg, #2CCB90, #22d3ee)',
        topBorder: 'linear-gradient(90deg, #2CCB90, #22d3ee)',
        glow: 'rgba(34,211,238,0.18)', glowColor: '#22d3ee', accentColor: '#0891b2',
    },
    {
        id: 'operacional', title: 'Visão Operacional', description: 'Gerenciamento operacional e coordenação de eventos',
        Icon: CogsIcon, path: '/eventos/operacional', perfis: ['super_admin', 'admin', 'diretor', 'operacional'],
        gradient: 'linear-gradient(135deg, #60a5fa, #22d3ee)',
        topBorder: 'linear-gradient(90deg, #60a5fa, #22d3ee)',
        glow: 'rgba(96,165,250,0.18)', glowColor: '#60a5fa', accentColor: '#2563eb',
    },
    {
        id: 'palestrante', title: 'Visão do Palestrante', description: 'Portal para palestrantes gerenciarem suas apresentações',
        Icon: MicIcon, path: '/eventos/palestrante', perfis: ['super_admin', 'admin', 'diretor', 'palestrante'],
        gradient: 'linear-gradient(135deg, #fb923c, #f43f5e)',
        topBorder: 'linear-gradient(90deg, #fb923c, #f43f5e)',
        glow: 'rgba(251,146,60,0.18)', glowColor: '#fb923c', accentColor: '#ea580c',
    },
];

const EventosHome = ({ supabase, session, clienteData, onLogout }) => {
    const navigate = useNavigate();
    const toast = useToast();
    const [menuOpen, setMenuOpen] = useState(false);

    const nomeUsuario = session?.user?.user_metadata?.nome || clienteData?.nome || 'Usuário';
    const emailUsuario = session?.user?.user_metadata?.email_real || session?.user?.email || '';
    const iniciais = nomeUsuario.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
    const userPerfil = session?.user?.user_metadata?.perfil || 'admin';

    const handleLogout = async () => {
        try { await onLogout(); } catch (e) { console.error(e); }
    };

    useEffect(() => {
        if (!menuOpen) return;
        const close = () => setMenuOpen(false);
        document.addEventListener('click', close);
        return () => document.removeEventListener('click', close);
    }, [menuOpen]);

    const availableModules = MODULOS.filter(m => m.perfis.includes(userPerfil));

    return (
        <>
            <style>{`
                .eh-card {
                    background: #ffffff; border: 1px solid #e2ede8;
                    border-radius: 20px; padding: 28px; cursor: pointer;
                    position: relative; overflow: hidden;
                    transition: all 0.28s cubic-bezier(0.16,1,0.3,1);
                    box-shadow: 0 2px 8px rgba(44,203,144,0.06), 0 1px 2px rgba(0,0,0,0.04);
                }
                .eh-card:hover { transform: translateY(-5px); }
                .eh-card:hover .eh-arrow { transform: translateX(5px); }
                .eh-arrow { transition: transform 0.2s; display: flex; align-items: center; }

                .eh-menu-item { display:flex; align-items:center; gap:10px; width:100%; padding:10px 14px; border-radius:10px; font-size:13px; font-weight:500; color:#475569; background:none; border:none; cursor:pointer; font-family:inherit; transition:all 0.15s; text-align:left; }
                .eh-menu-item:hover { background:#f0faf6; color:#0f172a; }
                .eh-menu-item.danger { color:#ef4444; }
                .eh-menu-item.danger:hover { background:rgba(239,68,68,0.06); color:#dc2626; }

                .eh-back-btn { display:flex; align-items:center; gap:6px; padding:7px 14px; border-radius:10px; background:#ffffff; border:1px solid #e2ede8; color:#64748b; font-size:13px; font-weight:500; cursor:pointer; font-family:inherit; transition:all 0.15s; }
                .eh-back-btn:hover { background:#f0faf6; color:#16a974; border-color:rgba(44,203,144,0.3); }

                @media (max-width:900px) { .eh-grid { grid-template-columns: repeat(2,1fr) !important; } }
                @media (max-width:600px) { .eh-grid { grid-template-columns: 1fr !important; } .eh-nav-email { display:none; } }
            `}</style>

            <div style={{ minHeight:'100vh', background:'#f0faf6', fontFamily:"'Inter', -apple-system, sans-serif", position:'relative', overflow:'hidden' }}>

                {/* Blobs de fundo */}
                <div style={{ position:'fixed', inset:0, pointerEvents:'none', zIndex:0 }}>
                    <div style={{ position:'absolute', top:'-10%', right:'-8%', width:'500px', height:'500px', borderRadius:'50%', background:'radial-gradient(circle, rgba(44,203,144,0.12) 0%, transparent 65%)', filter:'blur(60px)' }} />
                    <div style={{ position:'absolute', bottom:'-10%', left:'-8%', width:'450px', height:'450px', borderRadius:'50%', background:'radial-gradient(circle, rgba(45,184,225,0.1) 0%, transparent 65%)', filter:'blur(60px)' }} />
                </div>

                {/* Navbar */}
                <header style={{ position:'sticky', top:0, zIndex:50, background:'rgba(240,250,246,0.92)', backdropFilter:'blur(20px)', WebkitBackdropFilter:'blur(20px)', borderBottom:'1px solid #d1ece4' }}>
                    <div style={{ maxWidth:'1280px', margin:'0 auto', padding:'0 24px', height:'64px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
                            <div style={{ display:'inline-flex', alignItems:'center', background:'#fff', borderRadius:'10px', padding:'5px 14px', border:'1px solid #e2ede8', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', cursor:'pointer' }} onClick={() => navigate('/')}>
                                <img src="/logo-horizontal.png" alt="Evlo" style={{ height:'26px', objectFit:'contain' }} onError={e => { e.target.style.display='none'; }} />
                            </div>
                            <button className="eh-back-btn" onClick={() => navigate('/')}>
                                <ArrowLeftIcon /> Voltar ao Início
                            </button>
                            {clienteData && (
                                <span style={{ padding:'4px 12px', borderRadius:'100px', background:'rgba(44,203,144,0.1)', border:'1px solid rgba(44,203,144,0.25)', color:'#16a974', fontSize:'11px', fontWeight:700 }}>
                                    {clienteData.nome}
                                </span>
                            )}
                        </div>

                        <div style={{ position:'relative' }}>
                            <button
                                onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
                                style={{ display:'flex', alignItems:'center', gap:'10px', padding:'6px 12px', borderRadius:'12px', background: menuOpen ? '#f0faf6' : '#ffffff', border:'1px solid #e2e8f0', cursor:'pointer', transition:'all 0.15s', fontFamily:'inherit' }}
                            >
                                <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'linear-gradient(135deg, #2CCB90, #2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:700, color:'#fff', flexShrink:0 }}>
                                    {iniciais}
                                </div>
                                <div className="eh-nav-email" style={{ textAlign:'left' }}>
                                    <p style={{ margin:0, fontSize:'13px', fontWeight:600, color:'#0f172a' }}>{nomeUsuario}</p>
                                    <p style={{ margin:0, fontSize:'11px', color:'#94a3b8' }}>{emailUsuario}</p>
                                </div>
                                <span style={{ color:'#94a3b8', transition:'transform 0.2s', transform: menuOpen ? 'rotate(180deg)' : 'none' }}><ChevronIcon /></span>
                            </button>

                            {menuOpen && (
                                <div style={{ position:'absolute', top:'calc(100% + 8px)', right:0, minWidth:'200px', background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:'14px', boxShadow:'0 16px 48px rgba(0,0,0,0.1)', padding:'8px', zIndex:100 }}>
                                    <button className="eh-menu-item" onClick={() => { navigate('/perfil'); setMenuOpen(false); }}>Meu Perfil</button>
                                    <div style={{ height:'1px', background:'#f1f5f9', margin:'6px 0' }} />
                                    <button className="eh-menu-item danger" onClick={handleLogout}><LogoutIcon /> Sair</button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* Conteúdo */}
                <main style={{ position:'relative', zIndex:1, maxWidth:'1280px', margin:'0 auto', padding:'40px 24px 80px' }}>

                    {/* Cabeçalho */}
                    <div style={{ marginBottom:'40px' }}>
                        <div style={{ display:'inline-flex', alignItems:'center', gap:'7px', padding:'5px 14px', borderRadius:'100px', background:'rgba(44,203,144,0.12)', border:'1px solid rgba(44,203,144,0.25)', marginBottom:'16px' }}>
                            <span style={{ width:'7px', height:'7px', borderRadius:'50%', background:'#2CCB90', flexShrink:0 }} />
                            <span style={{ fontSize:'12px', fontWeight:700, color:'#16a974', textTransform:'uppercase', letterSpacing:'0.07em' }}>Módulos</span>
                        </div>
                        <h1 style={{ margin:'0 0 10px', fontSize:'clamp(28px,3.5vw,42px)', fontWeight:800, color:'#0f172a', letterSpacing:'-0.04em', lineHeight:1.15 }}>
                            Gerenciamento de <span style={{ background:'linear-gradient(90deg,#2CCB90,#2DB8E1)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>Eventos</span>
                        </h1>
                        <p style={{ margin:0, fontSize:'15px', color:'#64748b', lineHeight:1.6, maxWidth:'480px' }}>
                            {availableModules.length > 0 ? 'Escolha o módulo que deseja acessar' : 'Você não tem permissão para nenhum módulo'}
                        </p>
                    </div>

                    {/* Grid de módulos */}
                    {availableModules.length > 0 ? (
                        <>
                            <p style={{ margin:'0 0 16px', fontSize:'11px', fontWeight:700, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.1em' }}>
                                Módulos disponíveis
                            </p>
                            <div className="eh-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'20px', marginBottom:'32px' }}>
                                {availableModules.map((m, i) => (
                                    <div
                                        key={m.id}
                                        className="eh-card"
                                        onClick={() => navigate(m.path)}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.boxShadow = `0 16px 48px ${m.glowColor}28, 0 2px 8px rgba(0,0,0,0.06)`;
                                            e.currentTarget.style.borderColor = `${m.glowColor}55`;
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(44,203,144,0.06), 0 1px 2px rgba(0,0,0,0.04)';
                                            e.currentTarget.style.borderColor = '#e2ede8';
                                        }}
                                    >
                                        {/* Linha superior */}
                                        <div style={{ position:'absolute', top:0, left:0, right:0, height:'3px', background:m.topBorder, borderRadius:'20px 20px 0 0' }} />
                                        {/* Reflexo de canto */}
                                        <div style={{ position:'absolute', top:0, right:0, width:'120px', height:'120px', background:`radial-gradient(circle at top right, ${m.glow} 0%, transparent 65%)`, borderRadius:'0 20px 0 0', pointerEvents:'none' }} />

                                        <div style={{ position:'relative' }}>
                                            <div style={{ width:'52px', height:'52px', borderRadius:'14px', background:m.gradient, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'18px', color:'#fff', boxShadow:`0 4px 14px ${m.glow}` }}>
                                                <m.Icon />
                                            </div>
                                            <h3 style={{ margin:'0 0 6px', fontSize:'15px', fontWeight:700, color:'#0f172a', letterSpacing:'-0.01em' }}>{m.title}</h3>
                                            <p style={{ margin:'0 0 22px', fontSize:'13px', color:'#64748b', lineHeight:1.55 }}>{m.description}</p>
                                            <div style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'13px', fontWeight:600, color: m.accentColor }}>
                                                Acessar <span className="eh-arrow"><ArrowRightIcon /></span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Info card */}
                            <div style={{ display:'flex', alignItems:'center', gap:'16px', padding:'16px 20px', borderRadius:'16px', background:'#ffffff', border:'1px solid #e2ede8', borderLeft:'4px solid #2CCB90', boxShadow:'0 2px 8px rgba(44,203,144,0.06)' }}>
                                <div style={{ width:'36px', height:'36px', borderRadius:'10px', background:'linear-gradient(135deg, #2CCB90, #2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', flexShrink:0, boxShadow:'0 3px 10px rgba(44,203,144,0.3)' }}>
                                    <CalendarIcon />
                                </div>
                                <div>
                                    <p style={{ margin:'0 0 2px', fontSize:'13px', fontWeight:700, color:'#0f172a' }}>Sistema de Gerenciamento Completo</p>
                                    <p style={{ margin:0, fontSize:'12px', color:'#94a3b8' }}>Gerencie todos os aspectos dos seus eventos em um só lugar, do cadastro ao acompanhamento operacional em tempo real.</p>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div style={{ background:'rgba(239,68,68,0.05)', border:'1px solid rgba(239,68,68,0.15)', borderRadius:'16px', padding:'60px', textAlign:'center' }}>
                            <div style={{ width:'56px', height:'56px', borderRadius:'16px', background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.15)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', color:'#ef4444' }}>
                                <CalendarIcon />
                            </div>
                            <p style={{ margin:'0 0 6px', fontSize:'16px', fontWeight:700, color:'#ef4444' }}>Sem permissão de acesso</p>
                            <p style={{ margin:'0 0 20px', fontSize:'13px', color:'#94a3b8' }}>Seu perfil não tem acesso a nenhum módulo de eventos.</p>
                            <button onClick={() => navigate('/')} style={{ padding:'10px 20px', borderRadius:'10px', background:'rgba(239,68,68,0.06)', border:'1px solid rgba(239,68,68,0.2)', color:'#ef4444', fontSize:'14px', cursor:'pointer', fontFamily:'inherit', fontWeight:600 }}>
                                Voltar ao Início
                            </button>
                        </div>
                    )}
                </main>
            </div>
        </>
    );
};

export default EventosHome;
